/**
 * Alchemy Gardens — weekly recurring market stops as .ics
 * RRULE + America/Chicago so iOS/Android/Google treat events as recurring.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  /** Floating local wall time: YYYYMMDDTHHMMSS */
  function toIcsLocal(d) {
    return (
      d.getFullYear() +
      pad(d.getMonth() + 1) +
      pad(d.getDate()) +
      "T" +
      pad(d.getHours()) +
      pad(d.getMinutes()) +
      pad(d.getSeconds())
    );
  }

  /** UTC for DTSTAMP: YYYYMMDDTHHMMSSZ */
  function toIcsUtc(d) {
    return (
      d.getUTCFullYear() +
      pad(d.getUTCMonth() + 1) +
      pad(d.getUTCDate()) +
      "T" +
      pad(d.getUTCHours()) +
      pad(d.getUTCMinutes()) +
      pad(d.getUTCSeconds()) +
      "Z"
    );
  }

  function escapeIcs(text) {
    return String(text || "")
      .replace(/\\/g, "\\\\")
      .replace(/;/g, "\\;")
      .replace(/,/g, "\\,")
      .replace(/\r?\n/g, "\\n");
  }

  function foldLine(line) {
    // RFC 5545: lines should be <= 75 octets; fold with CRLF + space
    if (line.length <= 74) return line;
    var out = "";
    var i = 0;
    while (i < line.length) {
      var chunk = line.slice(i, i + (i === 0 ? 74 : 73));
      out += (i === 0 ? "" : "\r\n ") + chunk;
      i += chunk.length;
    }
    return out;
  }

  function parseHours(hours) {
    // "4–7:30pm", "8am–12pm", "3–6pm"
    if (!hours) return { start: [16, 0], end: [19, 30] };
    var s = hours.toLowerCase().replace(/\s+/g, " ").trim();
    s = s.replace(/[–—−]/g, "-");
    var parts = s.split("-");
    if (parts.length < 2) return { start: [16, 0], end: [19, 30] };

    function parseOne(part, forcePm) {
      part = part.trim();
      var pm = /pm/.test(part) || forcePm;
      var am = /am/.test(part);
      part = part.replace(/[ap]\.?m\.?/g, "").trim();
      var hm = part.split(":");
      var h = parseInt(hm[0], 10);
      var m = hm[1] ? parseInt(hm[1], 10) : 0;
      if (isNaN(h)) h = 12;
      if (isNaN(m)) m = 0;
      if (pm && h < 12) h += 12;
      if (am && h === 12) h = 0;
      return [h, m];
    }

    var endPm = /pm/.test(parts[1]);
    var startHasAm = /am/.test(parts[0]);
    var startPm = /pm/.test(parts[0]) || (endPm && !startHasAm);
    return {
      start: parseOne(parts[0], startPm && !startHasAm),
      end: parseOne(parts[1], endPm),
    };
  }

  function dayToByDay(day) {
    var d = (day || "").toLowerCase();
    // match anywhere: "Wednesdays", "Every Saturday", etc.
    if (/\bsun/.test(d)) return "SU";
    if (/\bmon/.test(d)) return "MO";
    if (/\btue/.test(d)) return "TU";
    if (/\bwed/.test(d)) return "WE";
    if (/\bthu/.test(d)) return "TH";
    if (/\bfri/.test(d)) return "FR";
    if (/\bsat/.test(d)) return "SA";
    return null;
  }

  function nextDateForByDay(byDay, fromDate) {
    var map = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 };
    var target = map[byDay];
    var d = fromDate ? new Date(fromDate.getTime()) : new Date();
    d.setHours(12, 0, 0, 0); // noon avoids DST edge when we set hours later
    var add = (target - d.getDay() + 7) % 7;
    d.setDate(d.getDate() + add);
    return d;
  }

  /** Downtown Midweek (Wed) always skips August for heat — even if the site card still shows normal hours */
  function isMidweekMarket(m) {
    var d = (m.day || "").toLowerCase();
    var n = (m.name || "").toLowerCase();
    return (
      /\bwed/.test(d) ||
      n.indexOf("midweek") !== -1 ||
      (n.indexOf("downtown") !== -1 && n.indexOf("market") !== -1)
    );
  }

  function isFullyCancelled(blob) {
    var b = (blob || "").toLowerCase();
    // August heat language is not a full cancel
    if (
      (b.indexOf("closed") !== -1 || b.indexOf("pause") !== -1) &&
      (b.indexOf("august") !== -1 ||
        b.indexOf("heat") !== -1 ||
        b.indexOf("resumes sept") !== -1 ||
        b.indexOf("resume sept") !== -1)
    ) {
      return false;
    }
    return (
      b.indexOf("closed") !== -1 ||
      b.indexOf("cancel") !== -1 ||
      b.indexOf("no market") !== -1 ||
      b.indexOf("shut down") !== -1 ||
      b.indexOf("hiatus") !== -1 ||
      b.indexOf("cancelled") !== -1
    );
  }

  /** Prefer explicit times like 4–7:30pm even if line mentions August close */
  function extractHoursForCalendar(hours) {
    var s = hours || "";
    var m = s.match(/(\d{1,2}(?::\d{2})?\s*(?:am|pm)?\s*[–—\-]\s*\d{1,2}(?::\d{2})?\s*(?:am|pm)?)/i);
    if (m) return m[1];
    if (/closed/i.test(s)) return "4–7:30pm";
    return s || "4–7:30pm";
  }

  /**
   * All August dates for a weekday in the season year (for EXDATE).
   * Midweek is closed all of August for heat, then resumes through November.
   */
  function augustDatesForByDay(byDay, seasonYear, hour, minute) {
    var map = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 };
    var target = map[byDay];
    var out = [];
    var d = new Date(seasonYear, 7, 1, 12, 0, 0); // Aug 1
    while (d.getMonth() === 7) {
      if (d.getDay() === target) {
        out.push(
          new Date(seasonYear, 7, d.getDate(), hour, minute, 0, 0)
        );
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

  /** First occurrence: skip into September if we're in August and this is midweek */
  function firstOccurrence(byDay, skipAugust, until) {
    var now = new Date();
    var y = until.getFullYear();
    if (skipAugust) {
      // In August of the season year → start first matching day in September
      if (now.getFullYear() === y && now.getMonth() === 7) {
        return nextDateForByDay(byDay, new Date(y, 8, 1, 12, 0, 0));
      }
      // Before August: normal next day, August dates excluded via EXDATE
      // After August (Sept–Nov): normal next day
    }
    return nextDateForByDay(byDay, now);
  }

  /**
   * Season end: last day of November (markets shut down for the year).
   * If we're already past that date, roll to next November.
   */
  function seasonUntilDate() {
    var now = new Date();
    var y = now.getFullYear();
    var until = new Date(y, 10, 30, 23, 59, 59); // Nov 30
    if (now.getTime() > until.getTime()) {
      until = new Date(y + 1, 10, 30, 23, 59, 59);
    }
    return until;
  }

  /** RRULE UNTIL in local floating form (matches TZID DTSTART) */
  function toRruleUntil(d) {
    return (
      d.getFullYear() +
      pad(d.getMonth() + 1) +
      pad(d.getDate()) +
      "T" +
      pad(d.getHours()) +
      pad(d.getMinutes()) +
      pad(d.getSeconds())
    );
  }

  /** VTIMEZONE for America/Chicago — helps phone apps keep weekly recurrence correct */
  function vtimezoneChicago() {
    return [
      "BEGIN:VTIMEZONE",
      "TZID:America/Chicago",
      "X-LIC-LOCATION:America/Chicago",
      "BEGIN:DAYLIGHT",
      "TZOFFSETFROM:-0600",
      "TZOFFSETTO:-0500",
      "TZNAME:CDT",
      "DTSTART:19700308T020000",
      "RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU",
      "END:DAYLIGHT",
      "BEGIN:STANDARD",
      "TZOFFSETFROM:-0500",
      "TZOFFSETTO:-0600",
      "TZNAME:CST",
      "DTSTART:19701101T020000",
      "RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU",
      "END:STANDARD",
      "END:VTIMEZONE",
    ];
  }

  function buildIcs(markets) {
    var lines = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//Alchemy Gardens//Markets//EN",
      "CALSCALE:GREGORIAN",
      "METHOD:PUBLISH",
      "X-WR-CALNAME:Alchemy Gardens Markets (Weekly)",
      "X-WR-TIMEZONE:America/Chicago",
    ].concat(vtimezoneChicago());

    var stamp = toIcsUtc(new Date());
    var until = seasonUntilDate();
    var untilStr = toRruleUntil(until);
    var untilLabel =
      until.toLocaleString("en-US", { month: "long", year: "numeric" });
    var eventCount = 0;

    markets.forEach(function (m, i) {
      var blob = ((m.name || "") + " " + (m.hours || "") + " " + (m.day || "")).toLowerCase();
      // Fully cancelled stops only — midweek stays, with August excluded
      if (isFullyCancelled(blob)) return;

      var byDay = dayToByDay(m.day);
      if (!byDay) return;

      var midweek = isMidweekMarket(m);
      var hoursForCal = extractHoursForCalendar(m.hours);
      var times = parseHours(hoursForCal);
      var base = firstOccurrence(byDay, midweek, until);
      // Don't start a series that begins after season end
      if (base.getTime() > until.getTime()) return;

      var start = new Date(base.getFullYear(), base.getMonth(), base.getDate(), times.start[0], times.start[1], 0, 0);
      var end = new Date(base.getFullYear(), base.getMonth(), base.getDate(), times.end[0], times.end[1], 0, 0);
      if (end <= start) {
        end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
      }

      var uid = "ag-market-weekly-" + until.getFullYear() + "-" + byDay + "-" + times.start[0] + times.start[1] + "-" + i + "@alchemygardensok.com";
      var title = (m.name || "Alchemy Gardens Market") + " (weekly through Nov)";
      var descParts = [];
      if (m.day) descParts.push(m.day);
      if (m.hours) descParts.push(m.hours);
      if (midweek) {
        descParts.push(
          "Weekly through " +
            untilLabel +
            ". Closed all of August for heat — no midweek markets that month; series skips August automatically."
        );
      } else {
        descParts.push("Weekly through " + untilLabel + " — then markets shut down for the season.");
      }
      descParts.push("Alchemy Gardens — come by and shop with us. Free samples when we have them.");
      descParts.push("https://alchemygardensok.com/pages/markets");
      var desc = descParts.join("\\n");
      var loc = m.where || "Tulsa, OK";

      // EXDATE: every Wednesday (etc.) in August of the season year
      var exdates = midweek
        ? augustDatesForByDay(byDay, until.getFullYear(), times.start[0], times.start[1])
        : [];

      lines.push("BEGIN:VEVENT");
      lines.push("UID:" + uid);
      lines.push("DTSTAMP:" + stamp);
      // TZID form — most reliable for weekly recurrence on phones
      lines.push("DTSTART;TZID=America/Chicago:" + toIcsLocal(start));
      lines.push("DTEND;TZID=America/Chicago:" + toIcsLocal(end));
      // Weekly until end of November (season shutdown)
      lines.push("RRULE:FREQ=WEEKLY;INTERVAL=1;BYDAY=" + byDay + ";UNTIL=" + untilStr);
      if (exdates.length) {
        // One EXDATE line with comma-separated local times (iOS/Google friendly)
        var ex =
          "EXDATE;TZID=America/Chicago:" +
          exdates
            .map(function (d) {
              return toIcsLocal(d);
            })
            .join(",");
        lines.push(ex);
      }
      lines.push("SUMMARY:" + escapeIcs(title));
      lines.push("DESCRIPTION:" + escapeIcs(desc.replace(/\\n/g, "\n")));
      lines.push("LOCATION:" + escapeIcs(loc));
      if (m.map_url) lines.push("URL:" + escapeIcs(m.map_url));
      lines.push("STATUS:CONFIRMED");
      lines.push("TRANSP:OPAQUE");
      lines.push("SEQUENCE:0");
      // Reminder 1 hour before each occurrence
      lines.push("BEGIN:VALARM");
      lines.push("TRIGGER:-PT1H");
      lines.push("ACTION:DISPLAY");
      lines.push("DESCRIPTION:Alchemy Gardens market in 1 hour");
      lines.push("END:VALARM");
      // Extra day-of reminder morning (optional)
      lines.push("BEGIN:VALARM");
      lines.push("TRIGGER:-PT4H");
      lines.push("ACTION:DISPLAY");
      lines.push("DESCRIPTION:Alchemy Gardens market today");
      lines.push("END:VALARM");
      lines.push("END:VEVENT");
      eventCount += 1;
    });

    lines.push("END:VCALENDAR");
    if (!eventCount) return null;
    return lines.map(foldLine).join("\r\n") + "\r\n";
  }

  function downloadIcs(ics, filename) {
    var blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = filename || "alchemy-gardens-markets-weekly.ics";
    document.body.appendChild(a);
    a.click();
    window.setTimeout(function () {
      URL.revokeObjectURL(url);
      a.remove();
    }, 800);
  }

  function bindRoot(root) {
    var btn = root.querySelector("[data-market-cal-download]");
    var jsonEl = root.querySelector("[data-market-cal-json]");
    if (!btn || !jsonEl) return;

    btn.addEventListener("click", function () {
      var markets;
      try {
        markets = JSON.parse(jsonEl.textContent.trim());
      } catch (e) {
        console.warn("Alchemy markets calendar: bad JSON", e);
        return;
      }
      if (!markets || !markets.length) return;

      var ics = buildIcs(markets);
      if (!ics) {
        alert("Could not build calendar — check that each market has a day (e.g. Wednesdays).");
        return;
      }
      var fname = btn.getAttribute("data-filename") || "alchemy-gardens-markets-weekly.ics";
      downloadIcs(ics, fname);
    });
  }

  function init() {
    document.querySelectorAll("[data-market-cal]").forEach(bindRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
